import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DocumentMeta from "react-document-meta";
import LoginHeader from "../Common/LoginHeader";
import Footer from "../Common/Footer";
import Moment from "moment";
import { ProductName } from "../Common/ProductName";
import {
  useTransCurrenciesQuery,
  useTransGetWithdrawsListMutation,
} from "../../redux/TransactionApi";
import { Decimal_util } from "../../utils/Dec.util";

const CoinWithdrawalFunction = () => {
  const meta = {
    title: `Withdrawal Transactions | ${ProductName} Exchange`,
    description: `Login on ${ProductName} Exchange now and start trading! Invite your friends to ${ProductName} Exchange.`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: `${ProductName} Exchange , Crypto Exchange, Buy Sell Crypto, Bitcoin Exchange India`,
      },
    },
  };

  const { data: currencies } = useTransCurrenciesQuery();
  const [getWithdrawsList] = useTransGetWithdrawsListMutation();
  const [transTitle, setTransTitle] = useState("Transaction Hash");
  const [transactions, setTransactions] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    perPage: 50,
    totalItems: 0,
  });

  // Auto-select first currency
  useEffect(() => {
    if (!selectedCurrency && currencies?.data?.length > 0) {
      setSelectedCurrency(currencies.data[0]);
    }
  }, [currencies]);

  // Fetch withdrawal list
  useEffect(() => {
    if (!selectedCurrency) return;
    fetchWithdrawals();
  }, [selectedCurrency, pagination.currentPage]);

  const fetchWithdrawals = async () => {
    try {
      const payload = {
        currency_id: selectedCurrency.id,
        page: pagination.currentPage,
        limit: pagination.perPage,
      };
      const { data } = await getWithdrawsList(payload);
      if (data?.status) {
        setTransactions(data.data || []);
        setPagination((prev) => ({
          ...prev,
          totalPages: data.pagination?.totalPages || 1,
          totalItems: data.pagination?.totalItems || 0,
        }));
      }
    } catch (err) {
      console.error("Error fetching withdrawals:", err);
    }
  };

  // Currency tabs
  const renderCoinList = () =>
    (currencies?.data || []).map((item) => (
      <li
        key={item.id}
        onClick={() => {
          setTransTitle(item.symbol === "INR" ? "UTR/TID" : "Transaction Hash");
          setSelectedCurrency(item);
          setPagination((prev) => ({ ...prev, currentPage: 1 }));
        }}
      >
        <span className={selectedCurrency?.id === item.id ? "active" : ""}>
          {item.symbol}
        </span>
      </li>
    ));

  // Table rows
  const renderTableRows = () =>
    transactions.length > 0 ? (
      transactions.map((e, i) => (
        <tr key={e.id}>
          <td>{i + 1}</td>
          <td>{Decimal_util.fixedtillString(e.amount, 8)}</td>
          <td>{e.withdraw_fee || 0}</td>
          <td>{e.tx_type}</td>
          <td className="ip_width">{e.tx_hash}</td>
          <td>{e.created}</td>
          <td className="text-capital">{e.status}</td>
          <td>{e?.payment_details?.reason ?? "-"}</td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="8" className="text-center">
          No Withdrawal Transactions Found
        </td>
      </tr>
    );

  // Pagination
  const renderPagination = () => {
    if (pagination.totalPages <= 1) return null;
    return (
      <div className="pagination-controls mt-3">
        <button
          className="btn"
          disabled={pagination.currentPage === 1}
          style={{ opacity: pagination.currentPage === 1 ? 0.5 : 1 }}
          onClick={() =>
            setPagination((prev) => ({
              ...prev,
              currentPage: prev.currentPage - 1,
            }))
          }
        >
          Prev
        </button>
        <span className="m-3">
          Page {pagination.currentPage} of {pagination.totalPages} (
          {pagination.totalItems} records)
        </span>
        <button
          className="btn"
          disabled={pagination.currentPage === pagination.totalPages}
          style={{
            opacity: pagination.currentPage === pagination.totalPages ? 0.5 : 1,
          }}
          onClick={() =>
            setPagination((prev) => ({
              ...prev,
              currentPage: prev.currentPage + 1,
            }))
          }
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <DocumentMeta {...meta}>
      <div>
        <LoginHeader />
        <div className="bg_light">
          <div className="new_inpage">
            <div className="container container2">
              <div className="white_box">
                {/* Tabs */}
                <ul className="nav nav-tabs2 mb-3">
                  <li className="nav-item">
                    <Link to="/mainWalletTransactions"> Main Wallet </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/spotHistory"> Spot </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/coinDeposite"> Deposit Coin </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/coinFundRequest" className="active">
                      Withdrawal
                    </Link>
                  </li>
                </ul>

                {/* Coin list */}
                <ul className="nav nav-tabs offer_beu spot">
                  {renderCoinList()}
                </ul>

                {/* Table */}
                <div className="tab-content">
                  <div className="tab-pane active" id="Balance">
                    <div className="rows">
                      <div className="wallet_box">
                        <div className="table-responsive">
                          <div className="scrool_wallet_box">
                            <table className="table table-striped mb-0">
                              <thead>
                                <tr>
                                  <th>Sr. No.</th>
                                  <th>Amount</th>
                                  <th>Withdrawal Fee</th>
                                  <th>Transaction Type</th>
                                  <th>{transTitle}</th>
                                  <th>Date & Time</th>
                                  <th>Status</th>
                                  <th>Reason</th>
                                </tr>
                              </thead>
                              <tbody>{renderTableRows()}</tbody>
                            </table>
                          </div>
                        </div>
                        {renderPagination()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </DocumentMeta>
  );
};

export default CoinWithdrawalFunction;
